<!-- <div class="container"> -->
<!-- View-mode strip (admins only): purple in Admin View, yellow while previewing as member -->
<ng-container *ngIf="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true'">
  <div class="gs-biz-strip gs-biz-strip--admin" role="status" *ngIf="businessData?.viewingAsMember != 'true'">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    <span>You are in <strong>Admin View</strong> &mdash; only you can see admin controls and metrics.</span>
    <button type="button" class="gs-biz-strip-btn gs-biz-strip-btn--preview" (click)="viewasmember()">Preview as Member</button>
  </div>
  <div class="gs-biz-strip gs-biz-strip--member" role="status" *ngIf="businessData?.viewingAsMember == 'true'">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
    <span>You are previewing as a member &mdash; this is what the public sees.</span>
    <button type="button" class="gs-biz-strip-btn gs-biz-strip-btn--exit" (click)="adminview()">Exit Preview</button>
  </div>
</ng-container>
<div class="business-banner-top post-box-shadow gs-biz-cover"
  [class.gs-biz-cover--after-strip]="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true'">
  <div class="business-banner">
    <div class="banner-shadow"></div>
    <img class="banner-img" [ngStyle]="{'background-image': coverBackground}">
    <div class="banner-overlay">
      <div class="banner-edit"
        *ngIf="(businessData?.isAdmin === 'true' || businessData?.isSuperAdmin === 'true') && businessData?.viewingAsMember != 'true'">
        <input type="file" accept=".jpg, .jpeg, .png" #myFileInput
               (click)="myFileInput.value=''"
               (change)="fileChangeEvent($event,template)" />
        <div class="image-upload"></div>
        <ng-icon name="tablerCamera" aria-hidden="true"></ng-icon>
        <span class="banner-edit-label">Edit Cover</span>
      </div>
    </div>
  </div>
</div>
<div class="hpanel scroll-header business-banner-top gs-biz-meta" style="word-wrap: break-word;">
  <div class="panel-body">
    <div class="col-md-12">

      <!-- Logo (overlapping the cover) + action buttons share one row -->
      <div class="gs-biz-logo-row">
      <div class="gs-biz-logo">
        <img src="{{businesslogs.src}}" alt="" onerror="this.src='assets/images/gallery/company.png';">
      </div>

      <div class="pull-right follow-menu">
        <div class="row mt-8px right ">
          <!-- Buttons: gs-biz-btn--filled = main action, --outline = secondary -->
          <!-- Admin View / Member View toggle (admins only); selected side follows ?viewingAsMember -->
          <div class="gs-biz-view-toggle" role="group" aria-label="Page view mode"
            *ngIf="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin=='true'">
            <button type="button" class="gs-biz-vt-btn"
              [class.active]="businessData?.viewingAsMember != 'true'"
              [attr.aria-pressed]="businessData?.viewingAsMember != 'true'"
              (click)="businessData?.viewingAsMember == 'true' && adminview()">Admin View</button>
            <button type="button" class="gs-biz-vt-btn"
              [class.active]="businessData?.viewingAsMember == 'true'"
              [attr.aria-pressed]="businessData?.viewingAsMember == 'true'"
              (click)="businessData?.viewingAsMember != 'true' && viewasmember()">Member View</button>
          </div>

          <button type="button" class="btn gs-biz-btn gs-biz-btn--outline" (click)="openProfileEdit()"
            *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin=='true') && businessData?.viewingAsMember != 'true'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>Edit Profile
          </button>

          <!-- Admins (not the Super Admin) can follow / unfollow too — Admin View
               only; Member View keeps its disabled preview Follow below. -->
          <ng-container *ngIf="businessData?.isAdmin == 'true' && businessData?.isSuperAdmin != 'true' && businessData?.viewingAsMember != 'true' && admindata != null">
            <button type="button" *ngIf="!admindata?.isFollow"
              (click)="addfollower()" class="btn gs-biz-btn gs-biz-btn--filled gs-biz-btn--follow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Follow
            </button>
            <button type="button" *ngIf="admindata?.isFollow"
              (click)="removefollower()" class="btn gs-biz-btn gs-biz-btn--outline">Unfollow</button>
          </ng-container>

            <button type="button" (click)="sendEmployeeRequest()" [disabled]="requestsent"
              *ngIf="businessData?.isAdmin === 'false' && businessData?.isSuperAdmin === 'false' && (admindata?.isEmployeeRequestRejected || admindata?.isRevokedEmployee)"
              class="btn gs-biz-btn gs-biz-btn--filled">
              Send Employee Request
            </button>
          <button type="button" disabled
            *ngIf=" businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && admindata?.isEmployeeRequestSent"
            class="btn gs-biz-btn gs-biz-btn--outline">Employee Request Sent</button>

          <button type="button"
            *ngIf=" businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && admindata?.isFollowerInvited && connectionStatus !== 'REQUEST_RECEIVED'"
            class="btn gs-biz-btn gs-biz-btn--filled" (click)="acceptFollowerRequest()">Accept Follow Request</button>

          <button type="button"
            *ngIf=" businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && admindata?.isFollowerInvited && connectionStatus !== 'REQUEST_RECEIVED'"
            class="btn gs-biz-btn gs-biz-btn--outline" (click)="rejectFollowerRequest()">Reject Follow Request</button>
          <button type="button"
            *ngIf=" businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && !admindata?.isFollow && !admindata?.isFollowerInvited && admindata!=null"
            (click)="addfollower()" class="btn gs-biz-btn gs-biz-btn--filled gs-biz-btn--follow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Follow
          </button>
          <button type="button"
            *ngIf="businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && admindata?.isFollow && admindata!=null"
            (click)="removefollower()" class="btn gs-biz-btn gs-biz-btn--outline">Unfollow</button>
          <button type="button"
            *ngIf="businessData?.isAdmin=='false' && businessData?.isSuperAdmin=='false' && admindata!=null"
            (click)="mgsBtn()" class="btn gs-biz-btn gs-biz-btn--outline">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Message
          </button>
          <!-- Member View preview: what visitors see, disabled for the admin -->
          <ng-container *ngIf="(businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true') && businessData?.viewingAsMember == 'true'">
            <button type="button" disabled title="Preview only" class="btn gs-biz-btn gs-biz-btn--filled gs-biz-btn--follow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Follow
            </button>
            <button type="button" disabled title="Preview only" class="btn gs-biz-btn gs-biz-btn--outline">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Message
            </button>
          </ng-container>
            <div class="iuiy1">
            <button type="button" style="pointer-events: none;" *ngIf="['CONNECTED', 'INACTIVE'].includes(connectionStatus)" class="btn gs-biz-btn gs-biz-btn--outline">
              Connected
            </button>
            <div class="gs-biz-btn-pair" *ngIf="connectionStatus === 'REQUEST_RECEIVED'">
              <button type="button" class="btn gs-biz-btn gs-biz-btn--filled" (click)="requestB2BContact('ACCEPT');">Accept Request</button>
              <button type="button" class="btn gs-biz-btn gs-biz-btn--outline" (click)="handleInvite('REJECT');">Reject Request</button>
            </div>
             <div *ngIf="(membershiptype === 'Starter' || membershiptype === 'Growth' || membershiptype === 'ScaleX' )&&role=='SUPERADMIN'&&connectionStatus=='NOT_CONNECTED'">
              <button type="button" class="btn gs-biz-btn gs-biz-btn--filled" (click)="requestB2BContact('CREATE')">
                Connect
              </button>
            </div>
            <div *ngIf="connectionStatus === 'REQUEST_SENT'&&role!='EMPLOYEE'">
              <button type="button" class="btn gs-biz-btn gs-biz-btn--outline" (click)="handleInvite('CANCEL');">
                Cancel Request
              </button>
            </div>
            <div ngbDropdown *ngIf="['CONNECTED', 'INACTIVE'].includes(connectionStatus)&&role!='EMPLOYEE'">
              <div class="  smxv" dropdown >
                <a id="button-animated" dropdownToggle class="gs-biz-btn gs-biz-btn--outline gs-biz-btn--icon" role="button" aria-label="More options">
                  <!-- Wireframe "more" icon (sharp SVG instead of the scaled PNG) -->
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                </a>
                <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="basic-link">
                  <li role="menuitem"><a class="dropdown-item" (click)="removeUserContact();">Remove Contact</a></li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <!-- <div *ngIf="!admindata?.isFollow&&!admindata?.isEmployee">
              Please follow the business page to view jobs
            </div> -->
      </div>
      </div>

      <div class="qwc">
        <h5 class="bus-hov business-name fw-bold-1" [routerLink]="['/landingPage/business']">Business Page</h5>
        <div class="business-name ellipse1 fw-bold" data-toggle="tooltip" data-placement="top"
           title="{{bannerdata?.businessName}}">
           {{ bannerdata?.businessName }}
        </div>
      </div>


      <div class="business-tag ellipse" style="display: none;" data-toggle="tooltip" data-placement="top"
        title="{{bannerdata?.tagLine }}">
        {{bannerdata?.tagLine }}</div>

      <!-- Details line: icon + text items; the "•" between them is drawn in CSS,
           so it only appears between items that exist. -->
      <div class="gs-biz-meta-row">
        <span class="gs-biz-meta-item gs-biz-meta-item--industry" *ngIf="industryClass" [title]="industryClass">
          <!-- Wireframe briefcase (tabler's variant has an extra middle line) -->
          <svg class="gs-biz-meta-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg><span class="gs-biz-meta-text">{{industryClass}}</span>
        </span>
        <span class="gs-biz-meta-item" *ngIf="bannerdata?.companyLocationDetails?.[0]?.city || bannerdata?.companyLocationDetails?.[0]?.state" [title]="heroLocation">
          <ng-icon name="tablerMapPin" aria-hidden="true"></ng-icon>{{bannerdata?.companyLocationDetails[0]?.city}} {{bannerdata?.companyLocationDetails[0]?.state}}
        </span>
        <span class="gs-biz-meta-item" *ngIf="bannerdata?.companyLocationDetails?.[0]?.website">
          <ng-icon name="tablerWorld" aria-hidden="true"></ng-icon>
          <a class="website" title="{{ bannerdata?.companyLocationDetails[0]?.website}}"
            [attr.href]="bannerdata?.companyLocationDetails[0]?.website.startsWith('http') ? bannerdata?.companyLocationDetails[0]?.website : 'http://'+bannerdata?.companyLocationDetails[0]?.website"
            target="_blank" rel="noopener noreferrer">{{bannerdata?.companyLocationDetails[0]?.website }}</a>
        </span>
        <span class="gs-biz-meta-item">
          <ng-icon name="tablerUsers" aria-hidden="true"></ng-icon>
          <a class="gs-biz-followers" (click)="followers()" title=" {{ admindata?.noOfFollowers }} {{ admindata?.noOfFollowers === 1 ? 'Follower' : 'Followers' }} ">{{ admindata?.noOfFollowers }} {{ admindata?.noOfFollowers === 1 ? 'Follower' : 'Followers' }}</a>
        </span>

        <!-- Social icons, pinned right; admins get "+ Add" -->
        <span class="gs-biz-meta-social" aria-label="Social media links"
          *ngIf="heroSocials.length || ((businessData?.isAdmin == 'true' || businessData?.isSuperAdmin == 'true') && businessData?.viewingAsMember != 'true')">
          <a *ngFor="let s of heroSocials; trackBy: trackBySocial" [href]="s.url" target="_blank" rel="noopener noreferrer"
            class="gs-biz-social-icon gs-biz-social-icon--{{ s.key }}" [attr.aria-label]="s.label" [title]="s.label">
            <svg *ngIf="s.key === 'linkedin'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            <svg *ngIf="s.key === 'twitter'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231z"/></svg>
            <svg *ngIf="s.key === 'youtube'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>
            <svg *ngIf="s.key === 'instagram'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            <svg *ngIf="s.key === 'facebook'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            <svg *ngIf="s.key === 'tiktok'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M21 7.917v4.034a9.948 9.948 0 0 1-5-1.951v4.5a6.5 6.5 0 1 1-8-6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z"/></svg>
          </a>
          <button type="button" class="gs-biz-social-add" (click)="openProfileEditor('social')" aria-label="Add social links"
            *ngIf="(businessData?.isAdmin == 'true' || businessData?.isSuperAdmin == 'true') && businessData?.viewingAsMember != 'true'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Add
          </button>
        </span>
      </div>

      <!-- Page tabs (replaced the left side menu) -->
      <app-navigation-header></app-navigation-header>




    </div>
  </div>
</div>

<ng-template #template>
  <div class="common-header-flex">
    <div>Banner Image</div>
    <button>
      <span class="common-close" (click)="closePhoto()">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4.5 / 1"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>
  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
        <button class="btn btn-primary" (click)="imageLoaded()">Apply</button>
      </div>
    </div>
  </div>
</ng-template>
<app-common-modal *ngIf="showModal"  [bannerpassingvalues]="bannervalues"(updateNetworkList)="refreshBusinessList($event)"[businessDetails]="businessDetails" [ownerid]="ownerbusinessId" [title]="selectedItem" [type]="'ADD'" (response)="closeModal($event)"></app-common-modal>






